const DB_NAME = "kritaka";
const STORE_NAME = "kv";
const DB_VERSION = 1;
let dbPromise = null;
function openDb() {
    if (dbPromise)
        return dbPromise;
    dbPromise = new Promise((resolve, reject) => {
        const req = indexedDB.open(DB_NAME, DB_VERSION);
        req.onupgradeneeded = () => {
            req.result.createObjectStore(STORE_NAME);
        };
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
    });
    return dbPromise;
}
function run(mode, fn) {
    return openDb().then((db) => new Promise((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, mode);
        const req = fn(tx.objectStore(STORE_NAME));
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
    }));
}
/**
 * IndexedDB-backed StorageAdapter. Works identically in a real browser and
 * in an Electron renderer, so both shells can use it as their base
 * StorageAdapter. Scoped to a single `kv` object store. Prefs, drafts,
 * read marks, and other small per-user state live here — relational cache
 * is the StructuredCacheAdapter's job (Desktop-only in phase 1).
 */
export const browserStorageAdapter = {
    async get(key) {
        return (await run("readonly", (store) => store.get(key))) ?? undefined;
    },
    async set(key, value) {
        await run("readwrite", (store) => store.put(value, key));
    },
    async delete(key) {
        await run("readwrite", (store) => store.delete(key));
    },
    async keys(prefix) {
        const allKeys = await run("readonly", (store) => store.getAllKeys());
        const asStrings = allKeys.map(String);
        return prefix ? asStrings.filter((k) => k.startsWith(prefix)) : asStrings;
    },
};
//# sourceMappingURL=storage.js.map